<template>
<div class="chapter">
<div class="inner_page">
<h1 class="subtitle"> <br/><br/><br/></h1>
<h1 class="subtitle">Hostage Bride</h1>
<h1 class="subtitle1">Anne Herries<br/><br/><br/><br/><br/><br/><br/><br/><br/></h1>
<p class="center"><img alt="" src="OEBPS/images/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?604b595a